//#region IMPORTS
import { fetchOrdersAsync, setOrderParams } from "./ordersSlice";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { ORDERSTATUS, ORDERTYPE } from "../../models/order";
import { useEffect } from "react";
import OrdersContainer from "../../components/orders/OrdersContainer";
//#endregion

//#region INTERFACE
interface Props {
  title: string;
}
//#endregion

export default function OrdersPendingPage({ title }: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  const { orders_loaded } = useAppSelector((state) => state.orders);
  //#endregion

  //#region LOGIC
  // set page specific filters
  useEffect(() => {
    dispatch(
      setOrderParams({
        limit: 50,
        sort: JSON.stringify({ column: "order_date", order: "desc" }),
        order_status: ORDERSTATUS.pending,
        order_type: ORDERTYPE.backorder,
        include_sub_orders: 1,
      })
    );
  }, [dispatch]);

  // Load orders
  useEffect(() => {
    const fetchOnload = async () => {
      if (!orders_loaded) {
        await dispatch(fetchOrdersAsync());
      }
    };
    fetchOnload();
  }, [orders_loaded, dispatch]);
  //#endregion

  //#region RENDER
  return <OrdersContainer title={title} />;
  //#endregion
}
